import React, { useMemo, useState, useCallback, useRef } from "react";


const cls = (...a) => a.filter(Boolean).join(" ");

export default function SubscriptionGate({ open, subscription, onRecheck, channelUrl, chatUrl }) {
  const [checking, setChecking] = useState(false);
  const [toast, setToast] = useState({ text: "", kind: "danger", visible: false, key: 0 });
  const lastToastAtRef = useRef(0);

  const channel = useMemo(() => subscription?.items?.find(i => i.role === "channel"), [subscription]);
  const chat = useMemo(() => subscription?.items?.find(i => i.role === "chat"), [subscription]);

  const channelHref = channel?.url || channelUrl || "";
  const chatHref = chat?.url || chatUrl || "";

  const bannerTextFromMissing = useCallback((missing) => {
    const a = Array.isArray(missing) && missing.includes("channel");
    const b = Array.isArray(missing) && missing.includes("chat");
    if (a && b) return "Не подписались на канал и чат";
    if (a) return "Не подписались на канал";
    if (b) return "Не подписались на чат";
    return "Подписка не подтверждена";
  }, []);

  const showToast = useCallback((text, kind = "danger", duration = 2400) => {
    const now = Date.now();
    if (now - lastToastAtRef.current < 500 && toast.visible) return;
    lastToastAtRef.current = now;
    const key = now;
    setToast({ text, kind, visible: true, key });
    window.setTimeout(() => {
      setToast(s => (s.key === key ? { ...s, visible: false } : s));
    }, duration);
  }, [toast.visible]);

  const handleRecheck = useCallback(async () => {
    if (checking) return;
    setChecking(true);
    let result;
    try {
      result = await onRecheck?.();
    } finally {
      setChecking(false);
    }
    if (typeof result?.success === "boolean") {
      if (!result.success) showToast(bannerTextFromMissing(result.missing));
      else setToast(s => ({ ...s, visible: false }));
      return;
    }
    if (!subscription?.success) showToast(bannerTextFromMissing(subscription?.missing));
    else setToast(s => ({ ...s, visible: false }));
  }, [checking, onRecheck, subscription?.success, subscription?.missing, bannerTextFromMissing, showToast]);

  if (!open) return null;

  return (
    <div className="subscr-overlay">
      <div className="subscr-wrap">
        <div className={cls("subscr-notice", toast.visible ? "show" : "hide", toast.kind)} key={toast.key} aria-live="polite">
          <div className="subscr-notice-dot" />
          <div className="subscr-notice-text">{toast.text}</div>
          <button className="subscr-notice-close" onClick={() => setToast(s => ({ ...s, visible: false }))}>×</button>
        </div>

        <div className="subscr-modal">
          <div className="subscr-header">Доступ по подписке</div>
          <div className="subscr-subtitle">Перейдите по кнопкам ниже, подпишитесь и подтвердите.</div>

          <div className="subscr-actions two">
            <a
              className={cls("subscr-btn ghost", channelHref ? "" : "disabled")}
              href={channelHref || "#"}
              target={channelHref ? "_blank" : "_self"}
              rel="noreferrer"
              onClick={e => { if (!channelHref) e.preventDefault(); }}
            >
              Канал
            </a>
            <a
              className={cls("subscr-btn ghost", chatHref ? "" : "disabled")}
              href={chatHref || "#"}
              target={chatHref ? "_blank" : "_self"}
              rel="noreferrer"
              onClick={e => { if (!chatHref) e.preventDefault(); }}
            >
              Чат
            </a>
          </div>

          <div className="subscr-status">
            {subscription?.items?.map(i => (
              <div key={i.role} className={cls("subscr-chip", i.ok ? "ok" : "nok")}>
                <span className="dot" />
                <span className="subscr-chip-text">
                  {i.role === "channel" ? "Канал" : "Чат"} • {i.ok ? "подписка активна" : "нет подписки"}
                </span>
              </div>
            ))}
          </div>

          {!subscription?.success && (
            <div className="subscr-footer one">
              <button
                className={cls("subscr-btn primary")}
                onClick={handleRecheck}
                disabled={checking}
              >
                {checking ? (
                  <>
                    <span className="btn-spinner" aria-hidden="true" />
                    <span className="btn-text">Проверяем…</span>
                  </>
                ) : (
                  "Подписался"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
